// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"26f15c26","453":"f2620443","549":"05a8df1e"}[chunkId] + ".chunk.js";
};